import { FloorLampTorchiereVariantOutlineIcon } from './FloorLampTorchiereVariantOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 03B09B13-4FA7-46CD-9E3B-48D460AB3986
 * name floor-lamp-torchiere-variant-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLightTorchiereVariantOutlineIcon = FloorLampTorchiereVariantOutlineIcon;
export default FloorLightTorchiereVariantOutlineIcon